import * as l from "react";
const e = (a) => /* @__PURE__ */ l.createElement(
  "svg",
  {
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...a
  },
  /* @__PURE__ */ l.createElement("g", { fill: "#2D6DED" }, /* @__PURE__ */ l.createElement("path", { d: "M14.755 3.362a.458.458 0 00-.637 0L3.876 13.617a.45.45 0 000 .638l3.842 3.847a.43.43 0 00.628 0l10.25-10.255a.459.459 0 000-.639l-3.84-3.846zM2.917 15.226a.459.459 0 00-.624-.012.43.43 0 00-.121.192l-1.948 5.77a.44.44 0 00.108.459.448.448 0 00.485.143l5.762-1.923a.467.467 0 00.296-.323.441.441 0 00-.125-.45l-3.833-3.856zM20.868 1.107a3.229 3.229 0 00-4.488 0l-.637.638a.45.45 0 000 .638l3.841 3.847a.457.457 0 00.629 0l.655-.63a3.172 3.172 0 00.69-3.463 3.172 3.172 0 00-.69-1.03z" }))
);
export {
  e as default
};
